import React from 'react';
import ReactDOM from 'react-dom';
import 'bootstrap/dist/css/bootstrap.css';
import "react-widgets/styles.css";
import './index.css';
import CreateRouter from './routes/router';
import reportWebVitals from './reportWebVitals';
import './fonts/Walt.ttf'
import './fonts/Brandon_light.otf';
import './fonts/Brandon_med.otf';
import './fonts/Brandon_reg.otf';
import './fonts/BurfordRusticBook-Regular2.otf';
import './fonts/BurfordRusticLine-Regular2.otf';
import './fonts/Brandon_light.otf';
import './fonts/BurfordRusticOutline.otf';
import { BrowserRouter } from 'react-router-dom';


ReactDOM.render(

    <BrowserRouter>
      <CreateRouter/>
    </BrowserRouter>,

  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
